import React from "react";

const Subscriptions = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31.926"
    height="21.949"
    viewBox="0 0 31.926 21.949"
    className={className}
  >
    <g id="credit-card">
      <path
        id="Path_40696"
        d="M31.926 85.176v-1.684A3.492 3.492 0 0 0 28.434 80H3.492A3.492 3.492 0 0 0 0 83.492v1.684a.312.312 0 0 0 .312.312h31.3a.312.312 0 0 0 .314-.312z"
        className="cls-1"
        transform="translate(0 -80)"
      />
      <path
        id="Path_40697"
        d="M0 201.312v9.568a3.492 3.492 0 0 0 3.492 3.492h24.942a3.492 3.492 0 0 0 3.492-3.492v-9.568a.312.312 0 0 0-.312-.312H.312a.312.312 0 0 0-.312.312zm7.982 7.074a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1z"
        className="cls-1"
        transform="translate(0 -192.422)"
      />
    </g>
  </svg>
);

export default Subscriptions;
